import { render } from "./SvgElementHighlight.vue?vue&type=template&id=052d1358&scoped=true"
import script from "./SvgElementHighlight.vue?vue&type=script&lang=js"
export * from "./SvgElementHighlight.vue?vue&type=script&lang=js"

import "./SvgElementHighlight.vue?vue&type=style&index=0&id=052d1358&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052d1358"]])

export default __exports__